var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 660,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-774 -69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M779 399C958.492 399 1104 253.492 1104 73.9999L1104 73.9999C1104 253.492 1249.51 399 1429 399L1429 399C1249.51 399 1104 544.507 1104 724L1104 724C1104 544.507 958.492 399 779 399Z",
    stroke: "#000000",
    strokeWidth: 10.3125,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco3);
export default __webpack_public_path__ + "static/media/deco3.06751ef3fb8c0f27da045684ffa00d5f.svg";
export { ForwardRef as ReactComponent };